import { useState } from "react";
import InputMascarado from "../formulario/input-mascarado/InputMascarado";
import { UseFormReturn } from "react-hook-form";
import { brasilApiService } from "../../services/api/brasil-api/brasilapi";

type BuscarCEPProps = {
  methods: UseFormReturn<any>;
  disabled?: boolean;
};

export function BuscarCEP({ methods, disabled = false }: BuscarCEPProps) {
  const [erro, setErro] = useState("");

  const buscar = async () => {
    const cep = methods.getValues("address.zipCode");

    if (cep) {
      try {
        setErro("");
        const response = await brasilApiService.getCep(cep.replace(/\D/g, ""));
        const data = response.data;

        methods.setValue("address.street", data.street || "");
        methods.setValue("address.neighborhood", data.neighborhood || "");
        methods.setValue("address.city", data.city || "");
        methods.setValue("address.state", data.state || "");
      } catch (error) {
        console.error(error);
        setErro("CEP inválido ou não encontrado.");
      }
    }
  };

  return (
    <InputMascarado
      onBlur={buscar}
      name="address.zipCode"
      label="CEP"
      methods={methods}
      helperText={erro}
      error={!!erro}
      disabled={disabled}
      mask={(value: string) =>
        value
          .replace(/\D/g, "")
          .replace(/^(\d{5})(\d)/, "$1-$2")
          .slice(0, 9)
      }
    />
  );
}
